<script setup lang="ts">
import Toast from 'primevue/toast'

import type { RSnackbarProps } from './RSnackbar.types.ts'

defineProps<RSnackbarProps>()
</script>

<template>
  <Toast
    v-bind="$props"
    data-testid="r-snackbar"
  >
    <template
      v-if="$slots.message"
      #message
    >
      <slot name="message" />
    </template>
    <template
      v-if="$slots.closeicon"
      #closeicon
    >
      <slot name="closeicon" />
    </template>
    <template
      v-if="$slots.container"
      #container
    >
      <slot name="container" />
    </template>
    <template
      v-if="$slots.messageicon"
      #messageicon
    >
      <slot name="messageicon" />
    </template>
  </Toast>
</template>

<style src="./RSnackbar.css"></style>

<i18n type="json" src="./RSnackbar.i18n.json"></i18n>
